// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("./IconV5.bs.js");
let Scroll = require("../../../reason/common/Scroll/Scroll.bs.js");
let DialogV5 = require("./DialogV5.bs.js");
let Container = require("./Container.bs.js");
let Next__Image = require("../../../reason/next/Next__Image.bs.js");
let ReactRender = require("../../../reason/utils/ReactRender.bs.js");
let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let VisuallyHidden = require("@reach/visually-hidden").default;
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ImageGalleryAllImages_image_graphql = require("../../../__generated__/ImageGalleryAllImages_image_graphql.bs.js");

let convertFragment = ImageGalleryAllImages_image_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ImageGalleryAllImages_image_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ImageGalleryAllImages_image_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(fRef) : undefined, ImageGalleryAllImages_image_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ImageGalleryAllImages_image_graphql.node, convertFragment, fRef);
}

let ImageFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ImageGallery__AllImages$CloseButton(props) {
  return JsxRuntime.jsxs("button", {
    children: [
      JsxRuntime.jsx(VisuallyHidden, {
        children: "Close"
      }),
      JsxRuntime.jsx("span", {
        children: JsxRuntime.jsx(IconV5.make, {
          icon: "cancel",
          size: 16
        }),
        "aria-hidden": true,
        className: "flex"
      })
    ],
    className: "border-transparent border-solid border cursor-pointer p-2 text-gray-700 hover:border-gray-300 hover:border hover:bg-gray-100 focus-visible:border-gray-300 focus-visible:bg-gray-100 focus-visible:border ",
    onClick: props.onPress
  });
}

let CloseButton = {
  make: ImageGallery__AllImages$CloseButton
};

function ImageGallery__AllImages(props) {
  let selectedImage = props.selectedImage;
  let isFullscreenCarouselOpen = props.isFullscreenCarouselOpen;
  let isFullscreenCarouselVisible = props.isFullscreenCarouselVisible;
  let onSelectImage = props.onSelectImage;
  let onClose = props.onClose;
  let images = RescriptRelay_Fragment.useFragment(ImageGalleryAllImages_image_graphql.node, convertFragment, props.images);
  let match = React.useReducer((state, action) => {
    switch (state) {
      case "Visible" :
        switch (action) {
          case "Unrender" :
            return "NotRendered";
          case "Render" :
          case "Show" :
            return state;
        }
      case "Invisible" :
        switch (action) {
          case "Unrender" :
          case "Render" :
            return state;
          case "Show" :
            return "Visible";
        }
      case "NotRendered" :
        switch (action) {
          case "Render" :
            return "Invisible";
          case "Unrender" :
          case "Show" :
            return state;
        }
    }
  }, "Visible");
  let send = match[1];
  let state = match[0];
  React.useEffect(() => {
    switch (state) {
      case "Visible" :
        if (isFullscreenCarouselVisible) {
          send("Unrender");
        }
        break;
      case "Invisible" :
        break;
      case "NotRendered" :
        if (isFullscreenCarouselOpen) {
          
        } else {
          send("Render");
        }
        break;
    }
  }, [
    isFullscreenCarouselVisible,
    isFullscreenCarouselOpen,
    state
  ]);
  React.useEffect(() => {
    switch (state) {
      case "Invisible" :
        if (isFullscreenCarouselVisible) {
          
        } else if (selectedImage !== undefined) {
          Scroll.scrollToHashIfNeeded("#image" + selectedImage.toString(), undefined, undefined);
          send("Show");
        } else {
          send("Show");
        }
        break;
      case "Visible" :
      case "NotRendered" :
        break;
    }
  }, [
    state,
    selectedImage,
    isFullscreenCarouselVisible
  ]);
  let shouldRender;
  switch (state) {
    case "Visible" :
    case "Invisible" :
      shouldRender = true;
      break;
    case "NotRendered" :
      shouldRender = false;
      break;
  }
  let onDismiss = React.useCallback(() => onClose(), [onClose]);
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
    children: JsxRuntime.jsx(DialogV5.make, {
      isOpen: props.isOpen,
      ariaLabel: "Photos",
      onDismiss: onDismiss,
      size: "FullScreen",
      showCloseButton: false,
      children: JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs(Container.make, {
          mobilePadding: false,
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(ImageGallery__AllImages$CloseButton, {
                onPress: param => onClose()
              }),
              className: "flex justify-end pt-4 pb-2"
            }),
            JsxRuntime.jsx("div", {
              children: ReactRender.ifTrue(images.map((img, i) => JsxRuntime.jsx("button", {
                children: JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(Next__Image.make, {
                    src: img.imgUrl,
                    width: 426,
                    height: 284,
                    unoptimized: true,
                    alt: "",
                    className: "object-cover max-w-full h-auto"
                  }),
                  className: "flex transition-filter duration-150 ease-in hover:brightness-75 hover:ease-out"
                }),
                id: "image" + i.toString(),
                onClick: param => onSelectImage(i)
              }, img.key)), shouldRender),
              className: TailwindMerge.twMerge([
                "opacity-100 grid grid-cols-2 gap-1 md:grid-cols-3 md:gap-2 transition-opacity duration-200 ease-out",
                state === "Visible" ? "" : "opacity-0"
              ])
            })
          ]
        })
      })
    })
  });
}

let make = ImageGallery__AllImages;

exports.ImageFragment = ImageFragment;
exports.CloseButton = CloseButton;
exports.make = make;
/* react Not a pure module */
